/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    forms: [
       { _id: 123, name: 'form template test 1' },
       { _id: 456, name: 'form template test 2' },
    ],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_FORMS:

            return {
                ...state,
                forms: action.payload,
            }

        default: return state;

    }

}

export default reducer;
